import { Component, OnInit, NgZone, ViewChild, ViewContainerRef, ComponentFactoryResolver, ElementRef } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { Ng2Datetime } from 'ng2-datetime-picker';
import { ExtraService } from '../../core/services/extra.service';
import { SessionService } from '../../core/services/session.service';
import { SessionTopicService } from '../../core/services/session-topic.service';
import { MapsAPILoader } from '@agm/core';
//import { } from 'googlemaps';
import { SpeakerService } from '../../core/services/speaker.service';
import * as firebase from 'firebase';
import { Session } from '../../core/models/session';
import { SessionTopic } from '../../core/models/session-topic';

import { Speaker } from '../../core/models/speaker';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { FileUpload } from '../../core/models/fileupload';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { MenuTypeService } from '../../core/services/menu-type.service';
import { EventPreferences } from '../../core/models/event-preferences';
import { error } from 'selenium-webdriver';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { HeaderImageSliderComponent } from '../../layout/header-image-slider/header-image-slider.component';
import { ChairpersonService } from '../../core/services/chairperson.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { min } from 'rxjs/operator/min';
import { SessionTrack } from '../../core/models/session-track';
import { SessionType } from '../../core/models/session-type';

@Component({
	selector: 'app-sessions-add',
	templateUrl: './sessions-add.component.html',
	styleUrls: ['./sessions-add.component.css'],
	providers: [DragulaService, SessionService, SpeakerService, ChairpersonService, DatePipe, ExtraService, NewPageService, MenuTypeService]
})
export class SessionsAddComponent implements OnInit {

	minDate = new Date();

	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;
	@ViewChild('template', { read: ViewContainerRef }) template: ViewContainerRef;

	@ViewChild("search")
	public searchElementRef: ElementRef;

	file_error_summary = Constants.VIDEO_SIZE_ERROR_MESSAGE_SUMMARY;
	file_error_detail = Constants.VIDEO_SIZE_ERROR_MESSAGE_DETAIL;
	file_size = Constants.VIDEO_SIZE;
	LABEL_SHORT_VENUE_DESCRIPTION = Constants.LABEL_SHORT_VENUE_DESCRIPTION;

	pageTitle: string = 'Add Sessions';
	pageAlias: string = 'sessions-form';
	disableButton: boolean = true;
	nameClass = 'form-control';
	startTimeClass = 'dateIcon';
	endTimeClass = 'dateIcon';
	locationClass = 'form-control';
	descClass = 'form-control';
	backgroundClass = 'description-bg';
	isChecked: boolean = false;
	dywadscreen: boolean = false;
	sectionName: boolean = false;
	eventLists: boolean = true;
	chairpersonList: boolean = true;
	coordinatorList: boolean = true;
	sessionTrackList : boolean=true;
	sessionTypeList : boolean=true;
	prop2: string;

	lat: number;
	long: number;
	latitude: number;
	longitude: number;
	showVenueTab: boolean;

	locationShort: string;
	locationAddress: string;
	public zoom: number;

	startDate: Date;
	endDate: Date;
	startTime: string = null;
	endTime: string = null;


	isError = false;
	message: string = '';
	errorMessage: string[];

	session = new Session();
	sessionId: string = null;
	eventId: string;
	speakerId: string = null;
	speakerList = new Array<Speaker>();
	sessionList = new Array<Session>();
	trackList = new Array<SessionTrack>();
	typesList = new Array<SessionType>();

	availableSpeakerList = [];
	availableChairpersonList = [];
	availableCoordinatorList = [];
	availableTrackList = [];
	availableTypeList = [];


	checkBoxSpeaker = new Array<boolean>();
	checkBoxChairPerson = new Array<boolean>();
	checkBoxCoordinator = new Array<boolean>();
	checkBoxTrack = new Array<boolean>();
	checkBoxTypes = new Array<boolean>();



	matchCustomLogoFileName: string;
	contentsMandatory = new ContentsMandatory();
	preferences = new EventPreferences();
	currentFileUpload: FileUpload;
	imageFile: File = null;
	progress: { percentage: number } = { percentage: 0 };

	categoryName = Constants.CONTENT_M_TYPE_SESSION;

	images: string[] = new Array();
	currentFiles = [];
	tagName = 'dragId';
	uploadprogress: number = null;
	uploadFileName: string = null;
	hasCoordinationOrderChange:boolean = false;
	hasSpeakerOrderChange:boolean = false;
	hasChairPersonOrderChange:boolean = false;
	
	
	

	popupWindow = null;

	sessionTopics = [
		// 	{
		// 	$key: '',
		// 	spakerList: [],
		// 	startTime: '',
		// 	endTime: '',
		// 	sessionKey: '',
		// 	title: '',
		// 	speaker: {
		// 		key: '',
		// 		name: ''
		// 	},

		// 	page: {
		// 		startTime: '',
		// 		endTime: '',
		// 		eventList: false
		// 	}
		// }
	];

	log(event: boolean) {
		console.log(`Accordion has been ${event ? 'closed' : 'opened'}`);
	}

	expComponent: any;

	/** new added */
	selectSpeaker: string = 'speaker';
	selectChairPerson: string = 'chairperson';
	selectCoordinator: string = 'coordinator';
	selectTrack:string = 'track';
	selectTypes:string = 'types';

	constructor(
		private dragula: DragulaService,
		private menuTypeService: MenuTypeService,
		private newPageService: NewPageService,
		private _cfr: ComponentFactoryResolver,
		private extraService: ExtraService,
		public datepipe: DatePipe,
		public mapsAPILoader: MapsAPILoader,
		private ngZone: NgZone, private route: ActivatedRoute, private router: Router,
		private sessionService: SessionService,
		private sessionTopicService: SessionTopicService,
		private speakarService: SpeakerService,
		private chairpersonService: ChairpersonService
	) {

		const bag: any = this.dragula.find(this.tagName);
		if (bag !== undefined) this.dragula.destroy(this.tagName);
		this.dragula.setOptions(this.tagName, {});
		let that = this;

		setInterval(function () {

			for (let i = 0; i < that.sessionTopics.length; i++) {

				that.topicTimeAsPerSession(i);

			}

		}, 1000);
	}

	uploadedFiles: any[] = [];
	galleryOptions: NgxGalleryOptions[];
	galleryImages: NgxGalleryImage[];


	arrayMove(array, from, to) {
		return array.splice(to, 0, array.splice(from, 1)[0]);
	}




	ngOnInit() {

		this.zoom = 4;


		let count = 0;
		this.extraService.castMenuTypeSubmit$.subscribe(isShow => {
			setTimeout(() => {

				this.disableButton = isShow;
				if (!this.disableButton) {
					this.message = 'File Uploading...';
				} else {
					if (count > 0) {
						this.message = 'File Uploaded Successfully';
					}
					count++;
				}
			});
		});

		// Sudhir Sir code Start ------------------------------------------------

		this.galleryOptions = [
			{
				width: '100%',
				height: '400px',
				thumbnailsColumns: 6,
				imageAnimation: NgxGalleryAnimation.Slide
			},
			// max-width 800
			{
				breakpoint: 800,
				width: '100%',
				height: '600px',
				imagePercent: 80,
				thumbnailsPercent: 20,
				thumbnailsMargin: 20,
				thumbnailMargin: 20
			},
			// max-width 400
			{
				breakpoint: 400,
				preview: false
			}
		];

		this.galleryImages = [
			{
				small: 'assets/img/partyImg1.jpg',
				medium: 'assets/img/partyImg2.jpg',
				big: 'assets/img/partyBanner.jpg'
			}
		];

		// Sudhir Sir code End ------------------------------------------------

		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.route.queryParams.subscribe(params => {
			let id = params['eventId'];
			let sessionID = params['sessionId'];
			if (params['eventId'] && !params['sessionId']) {
				this.eventId = params['eventId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.setSessionList(params['eventId']);
				this.setTrackList(params['eventId']);
				this.setTypesList(params['eventId']);

			}
			if (params['eventId'] && params['sessionId']) {
				this.eventId = params['eventId'];
				this.sessionId = params['sessionId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.setSessionDetails(params['eventId'], params['sessionId']);
				this.setSpeakerList(params['eventId']);
				this.setTrackList(params['eventId']);
				this.setTypesList(params['eventId']);
			} else {
				this.setSpeakerList(params['eventId']);
				this.setTrackList(params['eventId']);
				this.setTypesList(params['eventId']);
			}
		});

		this.newPageService.up$.subscribe(data => {
			if (data != null) {
				let index = this.session.aboutList.indexOf(data);
				if (index > 0) {
					this.swap(index, index - 1);
				}
			}
		});
		this.newPageService.down$.subscribe(data => {
			if (data != null) {
				let index = this.session.aboutList.indexOf(data);
				if (index < this.session.aboutList.length - 1) {
					this.swap(index, index + 1);
				}
			}
		});
		this.newPageService.remove$.subscribe(data => {
			if (data != null) {
				let index = this.session.aboutList.indexOf(data);
				//console.log(index);
				if (index != -1) {
					this.remove(index);
				}
			}
		});





	}

	addChairpersonToTopic(topic_index, speaker, isChecked) {
		console.log(topic_index, speaker, isChecked);

		if (Object.keys(this.sessionTopics[topic_index]).indexOf('chairpersonList') == -1)
			this.sessionTopics[topic_index]['chairpersonList'] = [];

		if (isChecked) {
			if (this.sessionTopics[topic_index].chairpersonList.indexOf(speaker.key) == -1) {
				this.sessionTopics[topic_index].chairpersonList.push(speaker.key)
			}
		} else {



			let speaker_index = this.sessionTopics[topic_index].chairpersonList.indexOf(speaker.key);
			if (speaker_index != -1) {
				this.sessionTopics[topic_index].chairpersonList.splice(speaker_index, 1);
			}
		}

		console.log("TOPICS_", this.sessionTopics[topic_index]);
	}
	addCoordinatorToTopic(topic_index, speaker, isChecked) {
		console.log(topic_index, speaker, isChecked);

		if (Object.keys(this.sessionTopics[topic_index]).indexOf('coordinatorList') == -1)
			this.sessionTopics[topic_index]['coordinatorList'] = [];

		if (isChecked) {
			if (this.sessionTopics[topic_index].coordinatorList.indexOf(speaker.key) == -1) {
				this.sessionTopics[topic_index].coordinatorList.push(speaker.key)
			}
		} else {



			let speaker_index = this.sessionTopics[topic_index].coordinatorList.indexOf(speaker.key);
			if (speaker_index != -1) {
				this.sessionTopics[topic_index].coordinatorList.splice(speaker_index, 1);
			}
		}

		console.log("TOPICS_", this.sessionTopics[topic_index]);
	}
	addSpeakerToTopic(topic_index, speaker, isChecked) {
		console.log(topic_index, speaker, isChecked);

		if (Object.keys(this.sessionTopics[topic_index]).indexOf('speakerList') == -1)
			this.sessionTopics[topic_index]['speakerList'] = [];

		if (isChecked) {
			if (this.sessionTopics[topic_index].speakerList.indexOf(speaker.key) == -1) {
				this.sessionTopics[topic_index].speakerList.push(speaker.key)
			}
		} else {



			let speaker_index = this.sessionTopics[topic_index].speakerList.indexOf(speaker.key);
			if (speaker_index != -1) {
				this.sessionTopics[topic_index].speakerList.splice(speaker_index, 1);
			}
		}

		console.log("TOPICS_", this.sessionTopics[topic_index]);
	}

	topicTimeAsPerSession(topic_index) {

		//console.log("SESSION_START_TIME", ((new Date(this.startDate).toISOString()).split("T")[0]));

		let sessionStartTimeDate = (new Date((new Date(this.startDate).toISOString()).split("T")[0] + " " + this.sessionTopics[topic_index].page.startTime));
		let sessionEndTimeDate = (new Date((new Date(this.startDate).toISOString()).split("T")[0] + " " + this.sessionTopics[topic_index].page.endTime));

		//console.log(topic_index, "START_TIME", sessionStartTimeDate);
		//console.log(topic_index, "END_TIME", sessionStartTimeDate);

		if (sessionStartTimeDate.toString() != "Invalid Date") {

			this.sessionTopics[topic_index].startTime = this.datepipe.transform(sessionStartTimeDate, Constants.DATE_TIME_FORMAT);

		}

		if (sessionEndTimeDate.toString() != "Invalid Date") {

			this.sessionTopics[topic_index].endTime = this.datepipe.transform(sessionEndTimeDate, Constants.DATE_TIME_FORMAT);

		}


	}

	moveTopic(direction, topic_index) {

		console.log(direction, topic_index);
		if (direction == 'up') {

			if (topic_index > 0) {

				// let that = this;
				// this.sessionTopics[topic_index].index = topic_index - 1;
				// let to = parseInt(topic_index) - 1;
				// let from = parseInt(topic_index);
				// this.sessionTopics.splice(to, 0, this.sessionTopics.splice(from, 1)[0]);
				let temp_details = this.sessionTopics[topic_index].page;

				this.sessionTopics[topic_index].page = this.sessionTopics[parseInt(topic_index) - 1].page;
				this.sessionTopics[parseInt(topic_index) - 1].page = temp_details;

			}

		} else {

			if (topic_index < this.sessionTopics.length) {

				// let that = this;
				// this.sessionTopics[topic_index].index = topic_index - 1;
				// let to = parseInt(topic_index) + 1;
				// let from = parseInt(topic_index);
				// this.sessionTopics.splice(to, 0, this.sessionTopics.splice(from, 1)[0]);

				let temp_details = this.sessionTopics[topic_index].page;

				this.sessionTopics[topic_index].page = this.sessionTopics[parseInt(topic_index) + 1].page;
				this.sessionTopics[parseInt(topic_index) + 1].page = temp_details;

			}

		}
	}

	addTopic() {
		console.log("Adding Topic");
		console.log(this.sessionTopics);

		let that = this;
		let session_id = (this.sessionId) ? this.sessionId.toString() : "";
		this.sessionTopics.push({
			$key: '',
			speakerList: [],
			startTime: '',
			endTime: '',
			sessionId: session_id,
			title: '',
			page: {
				startTime: '',
				endTime: '',
				eventList: false
			}
		})
	}

	setSearchInput() {
		setTimeout(function () {

			console.log("SearchElementRef", this.searchElementRef);
			console.log(this.mapsAPILoader);

			this.mapsAPILoader.load().then(() => {
				let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {

				});

				// To get latlong from location
				autocomplete.addListener("place_changed", () => {
					this.ngZone.run(() => {
						let place: google.maps.places.PlaceResult = autocomplete.getPlace();
						if (place.geometry === undefined || place.geometry === null) {
							return;
						}
						console.log(JSON.stringify(place));

						this.locationAddress = this.searchElementRef.nativeElement.value;
						this.lat = place.geometry.location.lat();
						this.long = place.geometry.location.lng();


						this.zoom = 12;
					});
				});
			});
		}.bind(this), 1500);
	}

	onChoseLocation(event) {
		this.latitude = event.coords.lat;
		this.longitude = event.coords.lng;

		// getting address from lat long
		var latlng = { lat: event.coords.lat, lng: event.coords.lng };
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode({ 'location': latlng }, (results, status) => {
			if (status) {
				if (results[0]) {
					console.log(JSON.stringify(results));
					this.searchElementRef.nativeElement.value = results[0].formatted_address;
					this.locationAddress = results[0].formatted_address;
				} else {
					this.searchElementRef.nativeElement.value = 'No results found';
				}
			} else {
				console.log('Geocoder failed due to: ' + status);
			}
		});

	}

	setSessionList(id) {
		var x = this.sessionService.getSessionList(id);
		x.snapshotChanges().subscribe(list => {
			this.sessionList = new Array();
			list.forEach(element => {
				var y = element.payload.toJSON() as Session;
				y['$key'] = element.key;
				this.sessionList[y.position] = (y as Session);
			});
		});
		console.log(this.session);
	}

	splitTiminigs(){
		if(this.startDate != null && this.endDate != null ){
			let totalTime = this.endDate.getTime() - this.startDate.getTime();
			totalTime = totalTime/60000
			let minToAdd = 0;
			if(this.sessionTopics.length>0){
				let listLength = this.sessionTopics.length;
				minToAdd = totalTime/listLength
				let _startTime = this.startDate
				this.sessionTopics.map((x,index)=>{
					let temp = this.dateAdd(_startTime,"minute",minToAdd)
					// console.log(index + 1 ,"Split : " + _startTime.toLocaleTimeString('en-GB', {
					// 	hour: '2-digit',
					// 	minute: '2-digit',
					// }) + "-" + temp.toLocaleTimeString('en-GB', {
					// 	hour: '2-digit',
					// 	minute: '2-digit',
					// }))
					x.page['startTime'] = _startTime.toLocaleTimeString('en-GB', {
						hour: '2-digit',
						minute: '2-digit',
					});
					x.page['endTime'] = temp.toLocaleTimeString('en-GB', {
						hour: '2-digit',
						minute: '2-digit',
					});
					_startTime = this.dateAdd(_startTime,"minute",minToAdd)
					return x;
				})
			}
			let startDate24 = moment(this.startDate.getTime(),'hh:mm A').format('HH:mm')
			console.log('startDate24',startDate24,this.sessionTopics)
		}
	}

	dateAdd(date, interval, units) {
		if(!(date instanceof Date))
		  return undefined;
		var ret = new Date(date); //don't change original date
		var checkRollover = function() { if(ret.getDate() != date.getDate()) ret.setDate(0);};
		switch(String(interval).toLowerCase()) {
		  case 'year'   :  ret.setFullYear(ret.getFullYear() + units); checkRollover();  break;
		  case 'quarter':  ret.setMonth(ret.getMonth() + 3*units); checkRollover();  break;
		  case 'month'  :  ret.setMonth(ret.getMonth() + units); checkRollover();  break;
		  case 'week'   :  ret.setDate(ret.getDate() + 7*units);  break;
		  case 'day'    :  ret.setDate(ret.getDate() + units);  break;
		  case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  break;
		  case 'minute' :  ret.setTime(ret.getTime() + units*60000);  break;
		  case 'second' :  ret.setTime(ret.getTime() + units*1000);  break;
		  default       :  ret = undefined;  break;
		}
		return ret;
	  }


	swap(index1, index2) {
		this.dropDown.move(this.dropDown.get(index1), index2);
		let data = this.session.aboutList[index1];
		this.session.aboutList[index1] = this.session.aboutList[index2];
		this.session.aboutList[index2] = data;
	}

	remove(index) {
		this.session.aboutList = this.session.aboutList.filter((val, i) => i != index);
	}

	showDropDown() {
		let aboutUs = new NewPageList();
		var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
		var expComponent = this.dropDown.createComponent(dropDown);
		this.session.aboutList.push(aboutUs);
		expComponent.instance.eventId = this.eventId;
		expComponent.instance._ref = expComponent;
		expComponent.instance.cmCategory = Constants.CONTENT_M_TYPE_SESSION;
		expComponent.instance.aboutUs = this.session.aboutList[this.session.aboutList.length - 1];
	}

	addComponent(about: NewPageList) {
		var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
		var expComponent = this.dropDown.createComponent(dropDown);
		expComponent.instance.eventId = this.eventId;
		expComponent.instance._ref = expComponent;
		expComponent.instance.cmCategory = Constants.CONTENT_M_TYPE_SESSION;
		expComponent.instance.aboutUs = about;
		if (about.type == 'image') {
			expComponent.instance.addImage();
		} else if (about.type == 'text') {
			expComponent.instance.addTextBox();
		} else if (about.type == 'cards') {
			expComponent.instance.addCards();
		} else if (about.type == 'video') {
			expComponent.instance.addVideo();
		} else if (about.type == 'url') {
			expComponent.instance.addUrlBox();
		} else if (about.type == 'youtubeVideo') {
			expComponent.instance.addYoutube();
		} else if (about.type == 'imageSlider') {
			expComponent.instance.addImageSlider();
		} else if (about.type == 'list') {
			expComponent.instance.addList();
		} else {
			expComponent.instance.addStatic(about.type);
		}
	}

	removeBackground() {
		if (this.session.hasDetailsScreen) {
			this.backgroundClass = 'description-gb';
		} else {
			this.backgroundClass = 'description-bg';
		}
	}


	setSpeakerList(event_id) {
		var x = this.speakarService.getSpeakerProfile(event_id);
		x.snapshotChanges().subscribe(list => {
			if (this.popupWindow !== null) {
				this.popupWindow.close();
			}
			this.speakerList = new Array();
			list.forEach(element => {
				var y = element.payload.toJSON();
				y['$key'] = element.key;
				let speakerObject = y as Speaker;
				this.speakerList.push(speakerObject);

				if (this.session.speakerList != null && this.session.speakerList.indexOf(element.key) != -1) {
					this.checkBoxSpeaker.push(true);
					this.availableSpeakerList.push({
						key: speakerObject.$key,
						name: speakerObject.name,
						id: `speaker-${speakerObject.$key}`
					});



				} else {
					this.checkBoxSpeaker.push(false);
				}

				if (this.session.chairpersonList != null && this.session.chairpersonList.indexOf(element.key) != -1) {

					this.checkBoxChairPerson.push(true);
					this.availableChairpersonList.push({
						key: speakerObject.$key,
						name: speakerObject.name,
						id: `chairperson-${speakerObject.$key}`
					});


				} else {
					this.checkBoxChairPerson.push(false);
				}

				if (this.session.coordinatorList != null && this.session.coordinatorList.indexOf(element.key) != -1) {

					this.checkBoxCoordinator.push(true);
					this.availableCoordinatorList.push({
						key: speakerObject.$key,
						name: speakerObject.name,
						id: `coordinator-${speakerObject.$key}`
					});


				} else {
					this.checkBoxCoordinator.push(false);
				}


			});
		});
	}

	setTrackList(event_id) {
		debugger
		var x = this.speakarService.getTrackProfile(event_id);
		x.snapshotChanges().subscribe(list => {
			if (this.popupWindow !== null) {
				this.popupWindow.close();
			}
			this.trackList = new Array();
			list.forEach(element => {
				var y = element.payload.toJSON();
				y['$key'] = element.key;
				let trackObject = y as SessionTrack;
				this.trackList.push(trackObject);

				if (this.session.tracks != null && this.session.tracks.indexOf(element.key) != -1) {
					this.checkBoxTrack.push(true);
					this.availableTrackList.push({
						key: trackObject.$key,
						name: trackObject.name,
						id: `track-${trackObject.$key}`
					});



				} else {
					this.checkBoxTrack.push(false);
				}

			});
		});
	}

	setTypesList(event_id) {
		debugger
		var x = this.speakarService.getTypeProfile(event_id);
		x.snapshotChanges().subscribe(list => {
			if (this.popupWindow !== null) {
				this.popupWindow.close();
			}
			this.typesList = new Array();
			list.forEach(element => {
				var y = element.payload.toJSON();
				y['$key'] = element.key;
				let typeObject = y as SessionType;
				this.typesList.push(typeObject);

				if (this.session.types != null && this.session.types.indexOf(element.key) != -1) {
					this.checkBoxTypes.push(true);
					this.availableTypeList.push({
						key: typeObject.$key,
						name: typeObject.name,
						id: `type-${typeObject.$key}`
					});



				} else {
					this.checkBoxTypes.push(false);
				}

			});
		});
	}
	addImageSlider() {

		var imageSlider = this._cfr.resolveComponentFactory(HeaderImageSliderComponent);
		this.expComponent = this.template.createComponent(imageSlider);

		this.expComponent.instance.eventId = this.eventId;
		this.expComponent.instance.cName = this.categoryName;
		this.expComponent.instance.categoryName = this.session.headerType;
		if (!this.session.headerContentMandatoryList) {
			this.session.headerContentMandatoryList = new Array<string>();
		}
		this.expComponent.instance.cmListArray = this.session.headerContentMandatoryList;
	}

	removeSlider() {
		if (this.expComponent) {
			this.expComponent.destroy();
		}
	}

	upCategoryItem(index,type) {
		if (index != 0) {
		  this.swapCategoryItem(index, index - 1,type);
		}
	}
	
	  downCategoryItem(index,type) {
		if (index != this.session.chairpersonList.length - 1) {
		  this.swapCategoryItem(index, index + 1,type);
		}
	  }
	
	  swapCategoryItem(index1, index2,type) {
		if(type==this.selectCoordinator){
			this.hasCoordinationOrderChange = true;
			let data = this.session.chairpersonList[index1];
			this.session.chairpersonList[index1] = this.session.chairpersonList[index2];
			this.session.chairpersonList[index2] = data;
		}
		
	  }

	setSessionDetails(eventID: string, sessionId: string) {
		console.log("fx", "setSessionDetails");
		this.sessionTopicService.getTopicList(eventID, sessionId).subscribe(topics => {

			this.sessionTopics = topics;
			// topics.forEach(topic => {
			// 	this.sessionTopics.push({
			// 		$key: topic.key,
			// 		startTime: '',
			// 		endTime: '',
			// 		sessionKey: '',
			// 		title: topic['title'],
			// 		speaker: {
			// 			key: "",
			// 			name: ''
			// 		},
			// 		page: {
			// 			startTime: '',
			// 			endTime: '',
			// 			eventList: false
			// 		}
			// 	})
			// });

			console.log("Topics", topics);
			/**
			 * Added By @ashutoshpw 
			 * @function Loading MapData
			 * 
			 * */

			let that = this;
			setTimeout(() => {

				if (that.session.hasDifferentVenue) {

					console.log("Latitude", that.session.latitude);
					console.log("Longitude", that.session.longitude);

					that.locationAddress = that.session.locationAddress;
					that.lat = Number(that.session.latitude);
					that.long = Number(that.session.longitude);
					that.zoom = 17



				} else {
					console.log("SESSION", that.session);
				}

			}, 500);

		});

		this.sessionService.getSingleSessionList(eventID, sessionId).subscribe(tempSession => {
			if (tempSession) {
				this.session = tempSession;

				if (tempSession && tempSession.hasDetailsScreen) {

					this.backgroundClass = 'description-gb';

					if (tempSession.headerType === 'image') {

						this.prop2 = 'Image';

					} else if (tempSession.headerType === 'imageSlider') {

						this.prop2 = 'Image Slider';
						setTimeout(() => {
							this.addImageSlider();
						}, 2000);

					} else if (tempSession.headerType === 'video') {

						this.prop2 = 'Video';

					} else if (tempSession.headerType === 'youtubeVideo') {

						this.prop2 = 'Youtube';

					}
				}

				if (this.session.headerContentMandatoryList != null && this.session.headerContentMandatoryList.length > 0) {
					for (var i = 0; i < 1; i++) {
						this.menuTypeService.getContentMendatoryMenuIdData(this.session.headerContentMandatoryList[i], eventID).subscribe(item => {
							if (item) {
								this.contentsMandatory = item;
								if (item.fileUrl) {
									this.contentsMandatory.fileUrl = item.fileUrl;
								}
							}
						});
					}
				} else if (this.session.headerContentMandatoryList != null && this.session.headerContentMandatoryList.length > 0 && tempSession.headerType == 'video') {
					for (var i = 0; i < this.session.headerContentMandatoryList.length; i++) {
						this.menuTypeService.getContentMendatoryMenuIdData(this.session.headerContentMandatoryList[i], eventID).subscribe(item => {
							if (item) {
								this.contentsMandatory = item;
								if (item.fileUrl) {
									this.contentsMandatory.fileUrl = item.fileUrl;
								}
							}
						});
					}
				}

				if (!this.session.speakerList) {
					this.session.speakerList = new Array<string>();
				}
				if (!this.session.chairpersonList) {
					this.session.chairpersonList = new Array<string>();
				}
				if (!this.session.coordinatorList) {
					this.session.coordinatorList = new Array<string>();
				}
				if (!this.session.tracks) {
					this.session.tracks = new Array<string>();
				}
				if (!this.session.types) {
					this.session.types = new Array<string>();
				}



				if (this.session.aboutList) {
					console.log(this.session.aboutList);
					this.session.aboutList.forEach(element => {
						this.addComponent(element);
					});
				} else {
					this.session.aboutList = new Array();
				}
				if (tempSession.startTime) {
					this.startDate = new Date(this.stringToFormatedDateString(tempSession.startTime));
					this.startTime = this.startDate.getHours() + ':' + this.startDate.getMinutes();
				}
				// let date = new Date();
				if (tempSession.endTime) {
					this.endDate = new Date(this.stringToFormatedDateString(tempSession.endTime));
					this.endTime = this.endDate.getHours() + ':' + this.endDate.getMinutes();
				}

			}
		});
	}

	//To format string for date
	stringToFormatedDateString(str: string): string {
		let formatedDateString = str;
		if (str.length == 17) {
			formatedDateString = str.substring(4, 8) + '-' + str.substring(2, 4) + '-' + str.substring(0, 2) + 'T' + str.substring(9);
		}
		return formatedDateString;
	}

	selectStartDate(event) {
		console.log(event);
		if (this.startTime) {
			if (this.startTime && this.startDate) {
				let timeData: string[] = this.startTime.split(':');
				let h: number = +timeData[0];
				let m: number = +timeData[1];
				this.startDate.setHours(h, m, 0);
				this.startDate = new Date(this.startDate);
			} else if (this.startDate) {
				this.startDate.setHours(0, 0, 0);
				this.startDate = new Date(this.startDate);
			}
		} else {
			this.startDate.setHours(9, 0, 0);
			this.startTime = '9:0';
			this.startDate = new Date(this.startDate);
		}
	}

	selectEndDate() {
		console.log(this.endDate);
		if (this.endTime) {
			if (this.endTime && this.endDate) {
				let timeData: string[] = this.endTime.split(':');
				let h: number = +timeData[0];
				let m: number = +timeData[1];
				this.endDate.setHours(h, m, 0);
				this.endDate = new Date(this.endDate);
			} else if (this.endDate) {
				this.endDate.setHours(0, 0, 0);
				this.endDate = new Date(this.endDate);
			}
		} else {
			this.endDate.setHours(9, 0, 0);
			this.endTime = '9:0';
			this.endDate = new Date(this.endDate);
		}
	}

	changeStartTime(event: string) {
		if (event && this.startDate) {
			this.startTime = event;
			let timeData: string[] = event.split(':');
			let h: number = +timeData[0];
			let m: number = +timeData[1];
			this.startDate.setHours(h, m, 0);
			this.startDate = new Date(this.startDate);
		} else if (this.startDate) {
			this.startDate.setHours(9, 0, 0);
			this.startTime = '9:0';
			this.startDate = new Date(this.startDate);
		}
	}

	changeEndTime(event: string) {
		if (event && this.endDate) {
			this.endTime = event;
			let timeData: string[] = event.split(':');
			let h: number = +timeData[0];
			let m: number = +timeData[1];
			this.endDate.setHours(h, m, 0);
			this.endDate = new Date(this.endDate);
		} else if (this.endDate) {
			this.endDate.setHours(9, 0, 0);
			this.endTime = '9:0';
			this.endDate = new Date(this.endDate);
		}
	}

	AddRemoveTopicSpeaker(topic_index, speaker) {

	}

	AddRemoveDataSourceChairperson(i, type: string) {
		if (type === this.selectSpeaker) {

			if (this.checkBoxSpeaker[i] === true) {

				this.availableChairpersonList.push({
					key: this.speakerList[i].$key,
					name: this.speakerList[i].name,
					id: `speaker-${this.speakerList[i].$key}`
				});

				this.session.speakerList.push(this.speakerList[i].$key);

			} else {

				const index: number = this.session.speakerList.indexOf(this.speakerList[i].$key);

				if (index != -1) {
					this.session.speakerList.splice(index, 1);
				}

				let topicSpeakerIndex: number = 0;
				for (let i = 0; i < this.availableChairpersonList.length; i++) {
					if (this.availableChairpersonList[i].key == this.speakerList[i].$key) {
						topicSpeakerIndex = i;
						break;
					}
				}

				if (topicSpeakerIndex != -1) {

					this.availableChairpersonList.splice(topicSpeakerIndex, 1);

				}

			}

		} else if (type === this.selectChairPerson) {
			if (this.checkBoxChairPerson[i] === true) {
				this.session.chairpersonList.push(this.speakerList[i].$key);
			} else {
				const index: number = this.session.chairpersonList.indexOf(this.speakerList[i].$key);
				if (index != -1) {
					this.session.chairpersonList.splice(index, 1);
				}
			}
		}
		else if (type === this.selectTrack) {
			if (this.checkBoxTrack[i] === true) {
				this.session.tracks.push(this.trackList[i].$key);
			} else {
				const index: number = this.session.tracks.indexOf(this.trackList[i].$key);
				if (index != -1) {
					this.session.tracks.splice(index, 1);
				}
			}
		}
		else if (type === this.selectTypes) {
			if (this.checkBoxTypes[i] === true) {
				this.session.types.push(this.typesList[i].$key);
			} else {
				const index: number = this.session.types.indexOf(this.typesList[i].$key);
				if (index != -1) {
					this.session.types.splice(index, 1);
				}
			}
		}
	}

	AddRemoveDataSourceCoord(i, type: string) {
		debugger
		if (type === this.selectSpeaker) {

			if (this.checkBoxSpeaker[i] === true) {

				this.availableCoordinatorList.push({
					key: this.speakerList[i].$key,
					name: this.speakerList[i].name,
					id: `speaker-${this.speakerList[i].$key}`
				});

				this.session.speakerList.push(this.speakerList[i].$key);

			} else {

				const index: number = this.session.speakerList.indexOf(this.speakerList[i].$key);

				if (index != -1) {
					this.session.speakerList.splice(index, 1);
				}

				let topicSpeakerIndex: number = 0;
				for (let i = 0; i < this.availableCoordinatorList.length; i++) {
					if (this.availableCoordinatorList[i].key == this.speakerList[i].$key) {
						topicSpeakerIndex = i;
						break;
					}
				}

				if (topicSpeakerIndex != -1) {

					this.availableCoordinatorList.splice(topicSpeakerIndex, 1);

				}

			}

		} else if (type === this.selectCoordinator) {
			if (this.checkBoxCoordinator[i] === true) {
				let key = this.speakerList[i].$key
				this.session.coordinatorList.push(key);
			} else {
				const index: number = this.session.coordinatorList.indexOf(this.speakerList[i].$key);
				if (index != -1) {
					this.session.coordinatorList.splice(index, 1);
				}
			}
		}
	}


	AddRemoveDataSource(i, type: string) {
		if (type === this.selectSpeaker) {

			if (this.checkBoxSpeaker[i] === true) {

				this.availableSpeakerList.push({
					key: this.speakerList[i].$key,
					name: this.speakerList[i].name,
					id: `speaker-${this.speakerList[i].$key}`
				});

				this.session.speakerList.push(this.speakerList[i].$key);

			} else {

				const index: number = this.session.speakerList.indexOf(this.speakerList[i].$key);

				if (index != -1) {
					this.session.speakerList.splice(index, 1);
				}

				let topicSpeakerIndex: number = 0;
				for (let i = 0; i < this.availableSpeakerList.length; i++) {
					if (this.availableSpeakerList[i].key == this.speakerList[i].$key) {
						topicSpeakerIndex = i;
						break;
					}
				}

				if (topicSpeakerIndex != -1) {

					this.availableSpeakerList.splice(topicSpeakerIndex, 1);

				}

			}

		} else if (type === this.selectChairPerson) {
			if (this.checkBoxChairPerson[i] === true) {
				this.session.chairpersonList.push(this.speakerList[i].$key);
			} else {
				const index: number = this.session.chairpersonList.indexOf(this.speakerList[i].$key);
				if (index != -1) {
					this.session.chairpersonList.splice(index, 1);
				}
			}
		}
	}

	//MenuHeader FileUpload event Fired //
	myMenuUploader(event) {
		this.message = null;
		this.currentFiles = event.files;
		this.imageFile = event.files[0];
		if (this.imageFile) {
			if (this.sectionName) {
				this.contentsMandatory.category = Constants.CONTENT_M_TYPE_SESSION;
			}

			if (this.prop2 === 'Image' || this.prop2 === 'Video') {
				this.session.headerContentMandatoryList = new Array();
			}

			this.session.headerContentMandatoryList = new Array();

			// Image or video FileUpload Event Fired //
			for (let file of event.files) {
				if ((this.matchCustomLogoFileName = file.name) != (this.contentsMandatory.filename) || (this.contentsMandatory.filename == null)) {
					this.contentsMandatory.filename = file.name;
					let extension = file.name;
					this.contentsMandatory.extension = extension.split('.').pop();
					this.contentsMandatory.sizeInBytes = file.size;
					this.contentsMandatory.category = Constants.CONTENT_M_TYPE_SESSION;
					this.contentsMandatory.eventId = this.eventId;
					//this.uploadedFiles.push(file);

					this.currentFileUpload = new FileUpload(file);
					let uploadTask = this.menuTypeService.pushUploadMenu(
						this.currentFileUpload,
						this.contentsMandatory.eventId,
						this.contentsMandatory.category,
					);

					uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
						(snapshot) => {
							// upload in progress
							this.disableButton = false;
							this.message = 'File uploading...';
							this.currentFileUpload.progress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);
						},
						(error) => {
							// upload failed
							this.disableButton = true;
							console.log(error);
						},
						() => {
							// upload success
							this.currentFileUpload.url = uploadTask.snapshot.downloadURL;
							if (this.prop2 === 'Image Slider') {
								this.images.push(this.currentFileUpload.url);
							}
							this.contentsMandatory.fileUrl = this.currentFileUpload.url;
							let menuID = this.menuTypeService.addMenuDetails(this.contentsMandatory, this.eventId);
							if (menuID) {
								console.log(menuID);
								this.session.headerContentMandatoryList.push(menuID);
								this.message = 'File Uploaded Successfully';
								this.disableButton = true;
							}
						}
					);
				}
			} //loop end
		}
	} // mymenuuploader end

	deleteImage(event) {
		console.log('currentFiles', this.currentFiles.length);
		this.uploadFileName = null;
		this.currentFileUpload.progress = null;
	}


	submit() {
		// this.validate();
		if (this.session.hasDifferentVenue) {
			this.session.locationAddress = this.locationAddress;
			this.session.latitude = this.lat;
			this.session.longitude = this.long;
			//this.session.locationShort = this.locationShort;
		} else {
			this.session.locationAddress = " ";
			//this.session.locationShort = " ";
			// try {
			// 	delete this.session.locationAddress;
			// 	delete this.session.locationShort;
			// } catch (e) {
			// 	console.error(e);
			// }
		}

		console.log("SESSION_TOPICS", this.sessionTopics);
		if (this.validate()) {

			this.showVenueTab = this.session.showVenueTab;

			this.session.startTime = this.datepipe.transform(this.startDate, Constants.DATE_TIME_FORMAT);
			this.session.endTime = this.datepipe.transform(this.endDate, Constants.DATE_TIME_FORMAT);


			if (this.sessionId == null) {
				this.add();

			} else {
				this.update();
				this.sessionTopics.forEach(topic => {

					this.sessionTopicService.addSessionTopicDetails(topic, this.eventId);

				})
			}
		} else {
			this.isError = true;
		}

	}

	validate() {
		this.isError = false;
		this.errorMessage = new Array();
		let valid = true;
		this.setDefaultClasses();
		this.session.aboutList.forEach(element => {
			if (element.type == 'text' && (element.text == null || element.text.trim().length < 1)) {
				if (this.errorMessage.indexOf('Text cannot empty') == -1) {
					this.errorMessage.push('Text cannot empty');
				}
				valid = false;
			}
			if (element.type == 'url' && (element.url == null || element.url.trim().length < 1)) {
				if (this.errorMessage.indexOf('Url cannot empty') == -1) {
					this.errorMessage.push('Url cannot empty');
				}
				valid = false;
			}
			if (element.type == 'youtubeVideo' && (element.url == null || element.url.trim().length < 1)) {
				if (this.errorMessage.indexOf('Youtube url cannot empty') == -1) {
					this.errorMessage.push('Youtube url cannot empty');
				}
				valid = false;
			}
			if (element.type == 'cards') {
				element.listItems.forEach(item => {
					if (item == null || item.trim().length < 1) {
						if (this.errorMessage.indexOf('Card text cannot empty') == -1) {
							this.errorMessage.push('Card text cannot empty');
						}
						valid = false;
					}
				});
			}
			if (element.type == 'image' && element.contentMandatoryList.length < 1) {
				if (this.errorMessage.indexOf('please browse an image') == -1) {
					this.errorMessage.push('please browse an image');
				}
				valid = false;
			}
			if (element.type == 'video' && element.contentMandatoryList.length < 1) {
				if (this.errorMessage.indexOf('please browse an video') == -1) {
					this.errorMessage.push('please browse an video');
				}
				valid = false;
			}
			if (element.type == 'list' && (element.listWithinListList == null || element.listWithinListList.length < 1)) {
				if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
					this.errorMessage.push('Add atleast one list item');
				}
				valid = false;
			} else if (element.type == 'list' && element.listWithinListList.length == 1 && element.listWithinListList[0].hasSubList == null) {
				if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
					this.errorMessage.push('Add atleast one list item');
				}
				valid = false;
			} else if (element.type == 'list' && element.listWithinListList != null && element.listWithinListList.length > 0) {
				element.listWithinListList.forEach(subList => {
					let bool = this.validateList(subList);
					if (!bool) {
						valid = false;
					}
				});
			}
			if (element.type == null || element.type.trim().length < 1) {
				this.remove(this.session.aboutList.indexOf(element));
			}

		});
		if (this.session.name == null || this.session.name.length < 3) {
			this.isError = true;
			this.errorMessage.push('Name is not valid');
			this.nameClass = 'fieldWithErrors form-control';
			valid = false;
		}

		if (this.startDate == null) {
			this.isError = true;
			this.errorMessage.push('Start Time can\'t be empty');
			this.startTimeClass = 'fieldWithErrors dateIcon';
			valid = false;
		}
		if (this.endDate == null) {
			this.isError = true;
			this.errorMessage.push('End Time can\'t be empty');
			this.endTimeClass = 'fieldWithErrors dateIcon';
			valid = false;
		}
		if (this.startDate != null && this.endDate != null && (this.dateDiff(this.endDate, this.startDate)) < 0) {
			this.isError = true;
			this.errorMessage.push('End Date cannot be less than the Start Date');
			this.endTimeClass = 'fieldWithErrors dateIcon';
			valid = false;
		}

		if (this.prop2 === 'Image') {
			this.session.headerType = 'image';
		}
		if (this.prop2 === 'Video') {
			this.session.headerType = 'video';
		}
		if (this.prop2 === 'Image Slider') {
			this.session.headerType = 'imageSlider';
		}
		if (this.prop2 === 'Youtube') {
			this.session.headerType = 'youtubeVideo';
		}
		return valid;
	}

	validateList(listWithinList: ListWithinList): boolean {
		let valid = true;
		if ((listWithinList.hasSubList != null && (listWithinList.text == null || listWithinList.text.length < 1))) {
			if (this.errorMessage.indexOf('list field cannot empty') == -1) {
				this.errorMessage.push('list field cannot empty');
			}
			valid = false;
		}
		if (listWithinList.hasSubList && listWithinList.listWithinListList != null && listWithinList.listWithinListList.length > 0) {
			listWithinList.listWithinListList.forEach(subList => {
				valid = this.validateList(subList);
			});
		}
		return valid;
	}

	dateDiff(date1, date2) {
		var datediff = date1.getTime() - date2.getTime();
		return (datediff / (24 * 60 * 60 * 1000));
	}

	setDefaultClasses() {
		this.nameClass = 'form-control';
		this.startTimeClass = 'dateIcon';
		this.endTimeClass = 'dateIcon';
		this.locationClass = 'form-control';
		this.descClass = 'form-control';
	}

	addNewSpeaker() {
		let windowW = screen.width * 0.8;
		let windowH = screen.height * 0.9;
		let LeftPosition = (screen.width) ? (screen.width - windowW) / 2 : 0;
		let TopPosition = (screen.height) ? (screen.height - windowH) / 2 : 0;
		let settings = 'height=' + windowH + ',width=' + windowW + ',top=' + TopPosition + ',left=' + LeftPosition + ',scrollbars=yes,resizable'
		this.popupWindow = window.open('http://' + window.location.host + '/event/speaker-profile?eventId=' + this.eventId, 'New Speaker', settings);
	}

	add() {
		this.disableButton = false;
		this.session.position = this.sessionList.length;
		let sessionDetails = this.session;

		let sessionKey = this.sessionService.addSessionDetails(sessionDetails, this.eventId);
		this.sessionTopics.forEach(topic => {

			topic['sessionId'] = sessionKey;
			this.sessionTopicService.addSessionTopicDetails(topic, this.eventId);

		});
		// this.sessionTopics.forEach(topics => {

		// 	delete topics.$key;
		// 	this.sessionTopicService.addSessionTopicDetails(topics, this.eventId);

		// });

		if (sessionKey) {
			this.message = 'Added Successfully';
			setTimeout(function () {
				this.message = null;
				this.disableButton = true;
				this.router.navigate([Constants.SESSION_FORM, this.eventId]);
			}.bind(this), 2000);
		}
		this.removeSlider();
	}

	update() {
		this.disableButton = false;
		let sessionDetails = this.session;
		this.sessionService.updateSessionDetails(sessionDetails, this.eventId, this.sessionId).then(res => {
			this.message = 'Updated Successfully';
		}).catch(error => {
			this.disableButton = true;
			this.errorMessage = error.message;
		});
		setTimeout(function () {
			this.message = null;
			this.disableButton = true;
			this.router.navigate([Constants.SESSION_FORM, this.eventId]);
		}.bind(this), 2000);
		this.removeSlider();
	}
	deleteTopic(topicKey: string, index: number) {

		console.log("Deleting Topic", topicKey)
		if (confirm("Do you really want to delete this topic? Topic will be deleted Instantly")) {
			let that = this;
			this.sessionTopicService.deleteSessionTopicById(topicKey, this.eventId).then(d => {
				that.sessionTopics.splice(index, 1);
			});
		}

	}


}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/sessions-add/sessions-add.component.ts